// @ts-check
/**
 *
 * @param {Date} lhs
 * @param {Date} rhs
 */
const sameYear = (lhs, rhs) => lhs.getFullYear() === rhs.getFullYear();
export default sameYear;
